<template>
  <div class="content">
    <template>
      <v-card
        :style="
          $vuetify.breakpoint.xs
            ? 'padding: 12px; margin: 4px'
            : 'padding: 18px; margin: 18px'
        "
      >
        <v-row
          v-if="loading"
          class="fill-height ma-5 flex-column"
          align="center"
          justify="center"
        >
          <v-progress-circular
            style="margin-bottom: 8px"
            :size="80"
            color="teal"
            indeterminate
          />
          <span style="font-size: 18px">Carregando...</span>
        </v-row>
        <div v-else>
          <v-row
            v-if="!loading"
            align="center"
            :justify="user.CodRole === 3 ? 'space-between' : 'start'"
          >
            <v-col
              v-if="user.CodRole === 3"
              class="pa-1"
              cols="12"
              sm="6"
              md="3"
            >
              <v-select
                v-model="agroindustria"
                :rules="[v => !!v || 'Obrigatório']"
                :items="agroindustrias"
                color="teal"
                item-text="display_nome"
                return-object
                label="Agroindústria"
                prepend-icon="mdi-factory"
                no-data-text="Sem agroindústrias"
                required
              />
            </v-col>
            <v-col class="pa-1" cols="12" sm="6" md="3">
              <v-menu
                v-model="menuDataIni"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                    :value="moment(dataInicio).format('DD/MM/YYYY')"
                    label="Data Inicial"
                    prepend-icon="mdi-calendar"
                    color="teal"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dataInicio"
                  style="margin: 0px"
                  :max="dataFim"
                  color="teal"
                  locale="pt-br"
                  @input="menuDataIni = false"
                />
              </v-menu>
            </v-col>
            <v-col class="pa-1" cols="12" sm="6" md="3">
              <v-menu
                v-model="menuDataFim"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                    :value="moment(dataFim).format('DD/MM/YYYY')"
                    color="teal"
                    label="Data Final"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dataFim"
                  :min="dataInicio"
                  :max="dataLimite"
                  color="teal"
                  locale="pt-br"
                  @input="menuDataFim = false"
                />
              </v-menu>
            </v-col>
            <v-col
              class="pa-1"
              cols="12"
              sm="6"
              :md="user.CodRole === 3 ? '3' : '6'"
            >
              <v-row justify="end" align="center">
                <v-btn
                  :disabled="loadingRelatorio"
                  style="color: white; border-radius: 8px"
                  color="green darken-1"
                  @click="geraRelatorio"
                >
                  <span style="font-size: 16px; font-weight: 500">Gerar</span>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          <div class="clearfix" />
          <v-card color="#28416a" class="white--text">
            <v-card-title primary-title>
              <v-row
                v-if="loadingRelatorio"
                class="fill-height ma-2 flex-column"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  style="margin-bottom: 8px"
                  :size="80"
                  color="white"
                  indeterminate
                />
                <span style="font-size: 18px">Obtendo relatório...</span>
              </v-row>
              <div
                v-else-if="relatorio"
                class="d-flex flex-column"
                style="margin: 12px 0px; width: 100%"
              >
                <div
                  class="d-flex flex-column flex-md-row justify-md-space-between align-md-center"
                >
                  <div>
                    <span style="font-size: 22px; font-weight: 500">
                      Relatório
                    </span>
                    <br />
                    <span style="font-size: 16px; font-weight: 400"
                      ><strong>Período:</strong>
                      {{
                        moment(dataInicio).format('DD/MM/YYYY') +
                        ' à ' +
                        moment(dataFim).format('DD/MM/YYYY')
                      }}</span
                    >
                    <br />
                    <span style="font-size: 16px; font-weight: 400">
                      <strong>Número de produtores consultados:</strong>
                      {{ relatorio.length }}
                    </span>
                  </div>
                  <div class="d-flex flex-column align-end">
                    <v-btn
                      color="success"
                      title="Exportar diagósticos completos em planilha EXCEL"
                      style="margin: 0px; margin-bottom: 4px"
                      @click="exportDiagnosticos"
                    >
                      <v-icon style="padding-right: 4px">
                        mdi-view-list
                      </v-icon>
                      EXPORTAR DIAGNÓSTICOS
                    </v-btn>
                    <div class="d-flex">
                      <v-btn
                        :loading="loadingBtnPDF"
                        icon
                        large
                        color="white"
                        title="Exportar PDF"
                        @click="exportPDF"
                      >
                        <v-icon>mdi-file-pdf</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        large
                        color="white"
                        title="Exportar EXCEL"
                        @click="exportExcel"
                      >
                        <v-icon>mdi-file-excel</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div>
                  <v-row>
                    <v-col cols="12" sm="6" lg="4">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        color="teal"
                        label="Pesquisar"
                        dark
                        flat
                        solo-inverted
                        hide-details
                        clearable
                        clear-icon="mdi-close"
                      />
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div v-else style="margin: 12px 0px">
                <span style="font-weight: 400">{{
                  user.CodRole === 3
                    ? 'Selecione uma agroindústria e determine o período que você deseja gerar o relatório de diagnósticos.'
                    : 'Determine o período que você deseja gerar o relatório de produtores.'
                }}</span>
              </div>
            </v-card-title>
          </v-card>
        </div>
        <div v-if="!loadingRelatorio && relatorio">
          <v-data-table
            :headers="headers"
            :items="relatorio"
            :search="search"
            no-results-text="Nenhum resultado para o texto pesquisado"
            item-key="id_resposta"
            calculate-widths
            fixed-header
            class="elevation-1 diretor-table mt-2"
          >
            <template v-slot:[`item.actions`]="{item}">
              <v-icon
                small
                title="Ver consulta completa"
                @click="getDiagnostico(item)"
              >
                mdi-clipboard-list
              </v-icon>
            </template>
            <template v-slot:[`item.consultor`]="{item}">
              {{ item.consultor ? item.consultor.nome : ' - ' }}
            </template>
            <template v-slot:[`item.dataFinalizacao`]="{item}">
              {{ moment(item.dataFinalizacao).format('DD/MM/YYYY HH:mm') }}
            </template>
            <template v-slot:no-data>
              <v-alert
                :value="noData"
                color="yellow darken-4"
                icon="mdi-alert-circle-outline"
              >
                Nenhum produtor consultado durante o período selecionado.
              </v-alert>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </template>
    <v-dialog
      v-model="dialogExport"
      persistent
      :fullscreen="$vuetify.breakpoint.xs"
      max-width="400px"
    >
      <v-card style="width: 100%; height: 300px; overflow: hidden">
        <v-row
          class="fill-height ma-2 flex-column"
          align="center"
          justify="center"
        >
          <v-progress-circular
            style="margin-bottom: 8px"
            :size="80"
            color="success"
            indeterminate
          />
          <span style="font-size: 18px">Preparando exportação...</span>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogDiagnostico"
      :fullscreen="$vuetify.breakpoint.xs"
      max-width="800px"
    >
      <v-card>
        <div
          class="d-flex flex-column flex-md-row justify-md-space-between align-md-center"
        >
          <v-card-title style="text-align: left; padding: 24px">
            <span class="headline">Visualização de consulta completa</span>
          </v-card-title>
          <div class="d-flex align-center justify-center">
            <v-btn
              :disabled="loadingDiagnostico"
              icon
              style="margin: 0px"
              color="error"
              title="Remover diagnóstico"
              @click="removeDiagnostico()"
            >
              <v-icon> mdi-delete </v-icon>
            </v-btn>
            <v-btn
              :disabled="loadingDiagnostico"
              icon
              color="#28416a"
              title="Exportar PDF"
              @click="exportDiagnosticoPDF"
            >
              <v-icon>mdi-file-pdf</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text>
          <v-row
            v-if="loadingDiagnostico"
            class="fill-height ma-5 flex-column"
            align="center"
            justify="center"
          >
            <v-progress-circular
              style="margin-bottom: 8px"
              :size="80"
              color="teal"
              indeterminate
            />
            <span style="font-size: 18px">Carregando...</span>
          </v-row>
          <div v-else-if="diagnostico">
            <v-card style="width: 100%" class="list-diagnostico" tile>
              <v-list two-line>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Agroindústria</v-list-item-title>
                    <v-list-item-subtitle>{{
                      diagnostico.industria_nome
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Consultor</v-list-item-title>
                    <v-list-item-subtitle>{{
                      diagnostico.consultor.nome
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Região</v-list-item-title>
                    <v-list-item-subtitle>{{
                      diagnostico.regiao || '-'
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Geolocalização</v-list-item-title>
                    <v-list-item-subtitle>{{
                      'Latitude: ' +
                      (diagnostico.latitude || '-') +
                      ' Longitude: ' +
                      (diagnostico.longitude || '-')
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      icon
                      title="Editar geolocalização"
                      @click="editGeolocalizacao()"
                    >
                      <v-icon color="grey"> mdi-pencil </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Cidade</v-list-item-title>
                    <v-list-item-subtitle>{{
                      diagnostico.cidade || '-'
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Estado</v-list-item-title>
                    <v-list-item-subtitle>{{
                      diagnostico.estado || '-'
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Data da consulta</v-list-item-title>
                    <v-list-item-subtitle>{{
                      moment(diagnostico.dataFinalizacao).format(
                        'DD/MM/YYYY HH:mm',
                      )
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      >Nomes (Com dependentes)</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      diagnostico.respostas
                        .filter(el => el.id_pergunta == 'nome')
                        .reduce(
                          (acc, curr, index, arr) =>
                            acc +
                            curr.resposta +
                            (arr.length - 1 == index ? '' : ', '),
                          '',
                        )
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon title="Editar membros" @click="editMembros()">
                      <v-icon color="grey"> mdi-pencil </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      >CPFs (Com dependentes)</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      diagnostico.respostas
                        .filter(el => el.id_pergunta == 'cpf')
                        .reduce(
                          (acc, curr, index, arr) =>
                            acc +
                            curr.resposta +
                            (arr.length - 1 == index ? '' : ', '),
                          '',
                        )
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      >Idades (Com dependentes)</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      diagnostico.respostas
                        .filter(el => el.id_pergunta == 'idade')
                        .reduce(
                          (acc, curr, index, arr) =>
                            acc +
                            curr.resposta +
                            (arr.length - 1 == index ? '' : ', '),
                          '',
                        )
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      >Sexos (Com dependentes)</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      diagnostico.respostas
                        .filter(el => el.id_pergunta == 'sexo')
                        .reduce(
                          (acc, curr, index, arr) =>
                            acc +
                            curr.resposta +
                            (arr.length - 1 == index ? '' : ', '),
                          '',
                        )
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <template v-for="(item, index) in survey">
                  <div
                    v-if="
                      diagnostico.respostas.find(
                        el => el.id_pergunta == item.questionId,
                      )
                    "
                    :key="index"
                  >
                    <v-divider />
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          item.questionText
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          diagnostico.respostas
                            .filter(el => el.id_pergunta == item.questionId)
                            .reduce(
                              (acc, curr, index, arr) =>
                                acc +
                                curr.resposta +
                                (arr.length - 1 == index ? '' : ', '),
                              '',
                            )
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          icon
                          title="Editar resposta"
                          @click="
                            editPergunta(
                              item,
                              diagnostico.respostas.filter(
                                el => el.id_pergunta == item.questionId,
                              ),
                            )
                          "
                        >
                          <v-icon color="grey"> mdi-pencil </v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </div>
                </template>
              </v-list>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPergunta" persistent max-width="800px">
      <v-card v-if="dialogPergunta">
        <v-card-title class="headline"> Edição de resposta </v-card-title>
        <v-row
          v-if="salvando"
          class="fill-height ma-5 flex-column"
          align="center"
          justify="center"
        >
          <v-progress-circular
            style="margin-bottom: 8px"
            :size="50"
            color="teal"
            indeterminate
          />
          <span style="font-size: 18px">Salvando alterações...</span>
        </v-row>
        <v-card-text
          v-else
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <v-card-subtitle style="padding: 0px">
            {{ perguntaEdit.questionText }}
          </v-card-subtitle>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-text-field
                v-if="
                  perguntaEdit.questionType === 'TextInput' ||
                  perguntaEdit.questionType === 'NumericInput'
                "
                v-model="respostasEdit[0].resposta"
                label="Resposta"
                hide-details
                solo
              />
              <v-select
                v-if="
                  perguntaEdit.questionType === 'SelectionGroup' ||
                  perguntaEdit.questionTypeOriginal === 'SelectionGroup'
                "
                v-model="respostasEdit[0].resposta"
                :items="perguntaEdit.options"
                item-text="optionText"
                item-value="optionText"
                label="Resposta"
                hide-details
                solo
              />
              <v-select
                v-if="
                  perguntaEdit.questionType === 'MultipleSelectionGroup' &&
                  !perguntaEdit.questionTypeOriginal
                "
                v-model="respostasMultiple"
                :items="perguntaEdit.options"
                item-text="optionText"
                item-value="optionText"
                label="Resposta"
                chips
                multiple
                hide-details
                solo
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions
          style="display: flex; justify-content: space-between; padding: 16px"
        >
          <v-btn
            :disabled="salvando"
            style="margin: 0px"
            color="error"
            @click="cancelaEditPergunta"
          >
            Cancelar
          </v-btn>
          <v-btn
            :disabled="salvando"
            style="margin: 0px"
            color="warning"
            @click="updatePergunta"
          >
            Salvar alteração
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMembros" persistent max-width="800px">
      <v-card v-if="dialogMembros">
        <v-card-title class="headline"> Edição de membros </v-card-title>
        <v-row
          v-if="salvando"
          class="fill-height ma-5 flex-column"
          align="center"
          justify="center"
        >
          <v-progress-circular
            style="margin-bottom: 8px"
            :size="50"
            color="teal"
            indeterminate
          />
          <span style="font-size: 18px">Salvando alterações...</span>
        </v-row>
        <v-card-text
          v-else
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <template v-for="(membro, index) in membros">
            <v-card v-if="!membro.delete" :key="index" style="margin: 12px 0px">
              <v-card-title>
                <v-row justify="space-between">
                  <div>
                    {{ 'Membro ' + (index + 1) }}
                  </div>
                  <v-btn
                    v-if="membros.length > 1"
                    icon
                    style="margin: 0px"
                    color="error"
                    title="Remover membro"
                    @click="removeMembro(index)"
                  >
                    <v-icon> mdi-delete </v-icon>
                  </v-btn>
                </v-row>
              </v-card-title>
              <v-card-text>
                <v-row justify="center" align="center">
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="membro.nome.resposta"
                      label="Nome"
                      placeholder="Resposta"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="membro.cpf.resposta"
                      v-mask="'###.###.###-##'"
                      label="CPF"
                      placeholder="Resposta"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="membro.idade.resposta"
                      v-mask="'###'"
                      label="Idade"
                      placeholder="Resposta"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="membro.sexo.resposta"
                      :items="[{value: 'Masculino'}, {value: 'Feminino'}]"
                      item-text="value"
                      item-value="value"
                      label="Sexo"
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </template>
          <v-row justify="center">
            <v-btn
              fab
              small
              style="margin: 0px"
              color="success"
              title="Adicionar membro"
              @click="addMembro()"
            >
              <v-icon> mdi-plus </v-icon>
            </v-btn>
          </v-row>
        </v-card-text>
        <v-card-actions
          style="display: flex; justify-content: space-between; padding: 16px"
        >
          <v-btn
            :disabled="salvando"
            style="margin: 0px"
            color="error"
            @click="cancelaEditMembros"
          >
            Cancelar
          </v-btn>
          <v-btn
            :disabled="salvando"
            style="margin: 0px"
            color="warning"
            @click="updateMembros"
          >
            Salvar alteração
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogGeolocalizacao" persistent max-width="800px">
      <v-card v-if="dialogGeolocalizacao">
        <v-card-title class="headline"> Edição de Geolocalização </v-card-title>
        <v-row
          v-if="salvando"
          class="fill-height ma-5 flex-column"
          align="center"
          justify="center"
        >
          <v-progress-circular
            style="margin-bottom: 8px"
            :size="50"
            color="teal"
            indeterminate
          />
          <span style="font-size: 18px">Salvando alterações...</span>
        </v-row>
        <v-card-text
          v-else
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <v-row style="width: 100%">
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="formGeolocalizacao.latitude"
                label="Latitude"
                @input="validaInputGeolocalizacao('latitude')"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="formGeolocalizacao.longitude"
                label="Longitude"
                @input="validaInputGeolocalizacao('longitude')"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions
          style="display: flex; justify-content: space-between; padding: 16px"
        >
          <v-btn
            :disabled="salvando"
            style="margin: 0px"
            color="error"
            @click="cancelaEditGeolocalizacao"
          >
            Cancelar
          </v-btn>
          <v-btn
            :disabled="salvando"
            style="margin: 0px"
            color="warning"
            @click="updateGeolocalizacao"
          >
            Salvar alteração
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import relatorio from '@/services/RelatorioPDF.js'
import listPDF from '@/services/ListPDF.js'
import survey from '@/utils/survey.js'
export default {
  data() {
    return {
      agroindustria: null,
      diagnostico: null,
      diagnosticoBackground: null,
      dataLimite: this.moment().toISOString(true).substr(0, 10),
      dataInicio: this.moment()
        .subtract(1, 'months')
        .toISOString(true)
        .substr(0, 10),
      dataFim: this.moment().toISOString(true).substr(0, 10),
      formGeolocalizacao: null,
      menuDataIni: false,
      menuDataFim: false,
      perguntaEdit: null,
      respostasEdit: null,
      membros: null,
      respostasMultiple: null,
      noData: false,
      loadingRelatorio: false,
      loadingDiagnostico: false,
      loadingBtnPDF: false,
      dialogDiagnostico: false,
      dialogPergunta: false,
      dialogMembros: false,
      dialogExport: false,
      dialogGeolocalizacao: false,
      agroindustrias: [],
      loading: true,
      salvando: false,
      relatorio: null,
      search: null,
      headers: [
        {text: '', value: 'actions', sortable: false, width: '40px'},
        {
          align: 'left',
          sortable: true,
          text: 'Produtor',
          value: 'resposta',
          width: '250px',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Fazenda',
          value: 'fazenda.resposta',
          width: '200px',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Consultor',
          value: 'consultor.nome',
          width: '250px',
        },
        {
          align: 'left',
          sortable: false,
          text: 'Região',
          value: 'regiao',
          width: '150px',
        },
        {
          align: 'left',
          sortable: false,
          text: 'Cidade',
          value: 'cidade',
          width: '200px',
        },
        {
          align: 'left',
          sortable: false,
          text: 'UF',
          value: 'estado',
          width: '120px',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Data - Hora',
          value: 'dataFinalizacao',
          width: '200px',
        },
      ],
    }
  },
  computed: {
    ...mapState({survey: state => state.survey, user: state => state.user}),
  },
  mounted() {
    if (this.user.CodRole === 3) {
      this.getAgroindustrias()
    } else {
      this.loading = false
    }
  },
  methods: {
    extractRespostas(respostas) {
      const objRespostas = {}
      const cnpj =
        this.user.CodRole === 3
          ? this.agroindustria.cnpj
          : this.user.agroindustria.cnpj
      objRespostas.nome = respostas
        .filter(el => el.id_pergunta === 'nome')
        .reduce(
          (acc, curr, index, arr) =>
            acc + curr.resposta + (arr.length - 1 === index ? '' : ', '),
          '',
        )
      objRespostas.cpf = respostas
        .filter(el => el.id_pergunta === 'cpf')
        .reduce(
          (acc, curr, index, arr) =>
            acc + curr.resposta + (arr.length - 1 === index ? '' : ', '),
          '',
        )
      objRespostas.idade = respostas
        .filter(el => el.id_pergunta === 'idade')
        .reduce(
          (acc, curr, index, arr) =>
            acc + curr.resposta + (arr.length - 1 === index ? '' : ', '),
          '',
        )
      objRespostas.sexo = respostas
        .filter(el => el.id_pergunta === 'sexo')
        .reduce(
          (acc, curr, index, arr) =>
            acc + curr.resposta + (arr.length - 1 === index ? '' : ', '),
          '',
        )
      survey
        .filter(item => !item.agroindustria || item.agroindustria === cnpj)
        .forEach(item => {
          objRespostas[item.questionId] = respostas
            .filter(elem => elem.id_pergunta === item.questionId)
            .reduce(
              (acc, curr, index, arr) =>
                acc + curr.resposta + (arr.length - 1 === index ? '' : ', '),
              '',
            )
        })
      return objRespostas
    },
    exportDiagnosticos() {
      this.dialogExport = true
      this.api
        .get('/diagnostic/getAll', {
          params: {
            cnpj:
              this.user.CodRole === 3
                ? this.agroindustria.cnpj
                : this.user.agroindustria.cnpj,
            data_inicio: this.dataInicio,
            data_fim: this.dataFim,
          },
        })
        .then(response => {
          const newArq = JSON.parse(
            JSON.stringify(
              response.data.map(el => {
                return {
                  consultor: el.consultor ? el.consultor.nome : ' - ',
                  regiao: el.regiao || ' - ',
                  cidade: el.cidade || ' - ',
                  uf: el.estado,
                  latitude: el.latitude || ' - ',
                  longitude: el.longitude || ' - ',
                  data: this.moment(el.dataFinalizacao).format(
                    'DD/MM/YYYY HH:mm',
                  ),
                  ...this.extractRespostas(el.respostas),
                }
              }),
            ),
          )
          const cnpj =
            this.user.CodRole === 3
              ? this.agroindustria.cnpj
              : this.user.agroindustria.cnpj
          const file = this.XLSX.utils.json_to_sheet(newArq, {
            header: [
              'consultor',
              'regiao',
              'cidade',
              'uf',
              'latitude',
              'longitude',
              'data',
              'nome',
              'cpf',
              'idade',
              'sexo',
              ...survey
                .filter(
                  item => !item.agroindustria || item.agroindustria === cnpj,
                )
                .map(item => item.questionId),
            ],
          })
          /* file['!cols'] = []
          Object.keys(newArq[0]).forEach((item, index) => {
            file['!cols'][index] = { wch: Math.max(item.length, ...newArq.map(elem => elem[item].toString().length)) }
          }) */
          file.A1.v = 'Consultor'
          file.B1.v = 'Região'
          file.C1.v = 'Cidade'
          file.D1.v = 'UF'
          file.E1.v = 'Latitude'
          file.F1.v = 'Longitude'
          file.G1.v = 'Data - Hora'
          file.H1.v = 'Nome'
          file.I1.v = 'CPF'
          file.J1.v = 'Idade'
          file.K1.v = 'Sexo'
          let c = 'L'
          let aux = ''
          survey
            .filter(item => !item.agroindustria || item.agroindustria === cnpj)
            .forEach(item => {
              // console.log(aux + c + '1')
              file[aux + c + '1'].v = item.questionText
              if (c === 'Z') {
                if (aux === '') {
                  aux = 'A'
                } else {
                  aux = String.fromCharCode(aux.charCodeAt(0) + 1)
                }
                c = 'A'
              } else {
                c = String.fromCharCode(c.charCodeAt(0) + 1)
              }
            })
          const wb = this.XLSX.utils.book_new()
          this.XLSX.utils.book_append_sheet(wb, file, 'file')
          if (this.user.CodRole === 3) {
            this.XLSX.writeFile(
              wb,
              'diagnosticos_' +
                this.agroindustria.Nome.replace(/ /g, '-') +
                '.xlsx',
            )
          } else {
            this.XLSX.writeFile(
              wb,
              'diagnosticos_' +
                this.user.agroindustria.Nome.replace(/ /g, '-') +
                '.xlsx',
            )
          }
          this.dialogExport = false
        })
    },
    removeDiagnostico() {
      this.Swal.fire({
        title: 'Remover diagnóstico',
        text:
          'Você tem certeza que deseja remover este diagnóstico? Ele será removido permanentemente do sistema.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#4caf50',
        cancelButtonColor: '#ff5252',
        confirmButtonText: 'Sim!',
        cancelButtonText: 'Não',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return this.api
            .delete('/diagnostic/delete', {
              params: {
                id: this.diagnostico.id,
              },
            })
            .then(() => {
              return 1
            })
            .catch(reject => {
              return reject.response.data
            })
        },
        allowOutsideClick: () => !this.Swal.isLoading(),
      }).then(result => {
        if (result.value === 1) {
          this.Swal.fire({
            icon: 'success',
            title: 'Tudo Certo!',
            text: 'O diagnóstico foi removido com sucesso.',
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.dialogDiagnostico = false
            this.geraRelatorio()
          })
        } else {
          this.Swal.fire(
            '',
            'Houve um erro ao tentar remover o diagnóstico.',
            'error',
          )
        }
      })
    },
    cancelaEditPergunta() {
      this.dialogPergunta = false
      this.diagnostico = this.diagnosticoBackground
      this.dialogDiagnostico = true
      this.respostasEdit = null
      this.respostasMultiple = null
      this.perguntaEdit = null
    },
    cancelaEditMembros() {
      this.dialogMembros = false
      this.diagnostico = this.diagnosticoBackground
      this.dialogDiagnostico = true
      this.membros = null
    },
    cancelaEditGeolocalizacao() {
      this.dialogGeolocalizacao = false
      this.diagnostico = this.diagnosticoBackground
      this.dialogDiagnostico = true
      this.formGeolocalizacao = null
    },
    updateMembros() {
      this.salvando = true
      const form = {membros: this.membros}
      this.api
        .post('/diagnostic/updateMembros', form)
        .then(response => {
          if (response.data.status) {
            this.Swal.fire(
              'Tudo certo!',
              'Os membros foram atualizados com sucesso.',
              'success',
            )
            this.dialogMembros = false
            this.diagnostico = this.diagnosticoBackground
            this.dialogDiagnostico = true
            this.membros = null
            this.salvando = false
            this.getDiagnostico(this.diagnostico)
          } else {
            this.Swal.fire(
              'Erro',
              'Houve um problema ao atualizar os membros.',
              'error',
            )
            this.salvando = false
          }
        })
        .catch(() => {
          // console.log(error)
          this.Swal.fire(
            'Erro',
            'Houve um problema ao atualizar os membros.',
            'error',
          )
          this.salvando = false
        })
    },
    updateGeolocalizacao() {
      if (
        !this.formGeolocalizacao.latitude ||
        !isFinite(this.formGeolocalizacao.latitude) ||
        Math.abs(this.formGeolocalizacao.latitude) > 90
      ) {
        this.Swal.fire(
          'Erro',
          'O valor de latitude está inválido. Este valor precisa ser um número no formato 00.000000 e está entre -90 e 90.',
          'error',
        )
      } else if (
        !this.formGeolocalizacao.longitude ||
        !isFinite(this.formGeolocalizacao.longitude) ||
        Math.abs(this.formGeolocalizacao.longitude) > 180
      ) {
        this.Swal.fire(
          'Erro',
          'O valor de longitude está inválido. Este valor precisa ser um número no formato 00.000000 e está entre -180 e 180.',
          'error',
        )
      } else {
        this.salvando = true
        this.api
          .post('/diagnostic/updateGeolocalizacao', this.formGeolocalizacao)
          .then(response => {
            if (response.data.status) {
              this.Swal.fire(
                'Tudo certo!',
                'A geolocalização foi atualizada com sucesso.',
                'success',
              )
              this.dialogGeolocalizacao = false
              this.diagnostico = this.diagnosticoBackground
              this.dialogDiagnostico = true
              this.formGeolocalizacao = null
              this.salvando = false
              this.getDiagnostico(this.diagnostico)
            } else {
              this.Swal.fire(
                'Erro',
                'Houve um problema ao atualizar a geolocalização.',
                'error',
              )
              this.salvando = false
            }
          })
          .catch(() => {
            // console.log(error)
            this.Swal.fire(
              'Erro',
              'Houve um problema ao atualizar a geolocalização.',
              'error',
            )
            this.salvando = false
          })
      }
    },
    updatePergunta() {
      this.salvando = true
      const form = {perguntas: []}
      if (
        this.perguntaEdit.questionType !== 'MultipleSelectionGroup' ||
        this.perguntaEdit.questionTypeOriginal
      ) {
        form.perguntas.push(this.respostasEdit[0])
      } else {
        if (this.respostasEdit.length === this.respostasMultiple.length) {
          this.respostasEdit.forEach((el, index) => {
            el.resposta = this.respostasMultiple[index]
            el.delete = false
          })
        } else if (this.respostasEdit.length < this.respostasMultiple.length) {
          this.respostasEdit.forEach((el, index) => {
            el.resposta = this.respostasMultiple[index]
            el.delete = false
          })
          for (
            let i = 0;
            i < this.respostasMultiple.length - this.respostasEdit.length;
            i++
          ) {
            this.respostasEdit.push({
              id_pergunta: this.respostasEdit[this.respostasEdit.length - 1]
                .id_pergunta,
              id_diagnostico: this.respostasEdit[this.respostasEdit.length - 1]
                .id_diagnostico,
              resposta: this.respostasMultiple[this.respostasEdit.length + i],
            })
          }
        } else if (this.respostasEdit.length > this.respostasMultiple.length) {
          this.respostasMultiple.forEach((el, index) => {
            this.respostasEdit[index].resposta = el
          })
          for (
            let i = this.respostasMultiple.length;
            i < this.respostasEdit.length;
            i++
          ) {
            this.respostasEdit[i].delete = true
          }
        }
        form.perguntas = this.respostasEdit
      }
      if (!form.perguntas.filter(el => !el.delete).length) {
        this.Swal.fire('Erro', 'Selecione uma resposta.', 'error')
        this.salvando = false
      } else {
        this.api
          .post('/diagnostic/update', form)
          .then(response => {
            if (response.data.status) {
              this.Swal.fire(
                'Tudo certo!',
                'A resposta foi alterada com sucesso.',
                'success',
              )
              this.dialogPergunta = false
              this.diagnostico = this.diagnosticoBackground
              this.dialogDiagnostico = true
              this.respostasEdit = null
              this.respostasMultiple = null
              this.perguntaEdit = null
              this.salvando = false
              this.getDiagnostico(this.diagnostico)
            } else {
              this.Swal.fire(
                'Erro',
                'Houve um problema ao atualizar a resposta.',
                'error',
              )
              this.salvando = false
            }
          })
          .catch(() => {
            // console.log(error)
            this.Swal.fire(
              'Erro',
              'Houve um problema ao atualizar a resposta.',
              'error',
            )
            this.salvando = false
          })
      }
    },
    validaInputGeolocalizacao(item) {
      let maskValue = ''
      for (let i = 0; i < this.formGeolocalizacao[item].length; i++) {
        if (
          ['-', '.', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].includes(
            this.formGeolocalizacao[item][i],
          )
        ) {
          maskValue += this.formGeolocalizacao[item][i]
        }
      }
      this.formGeolocalizacao[item] = maskValue
      // console.log(this.formGeolocalizacao.latitude)
      this.$forceUpdate()
    },
    editGeolocalizacao() {
      this.formGeolocalizacao = {
        id: this.diagnostico.id,
        latitude: this.diagnostico.latitude,
        longitude: this.diagnostico.longitude,
      }
      this.dialogGeolocalizacao = true
      this.dialogDiagnostico = false
      this.diagnostico = null
    },
    editPergunta(pergunta, respostas) {
      this.perguntaEdit = pergunta
      this.respostasEdit = respostas.map(el => {
        return {
          id: el.id,
          id_diagnostico: el.id_diagnostico,
          id_pergunta: el.id_pergunta,
          resposta: el.resposta,
        }
      })
      this.respostasMultiple = respostas.map(el => el.resposta)
      this.dialogPergunta = true
      this.dialogDiagnostico = false
      this.diagnostico = null
    },
    editMembros() {
      this.membros = []
      this.diagnosticoBackground.respostas
        .filter(el => el.id_pergunta === 'nome')
        .forEach(el => {
          this.membros.push({
            nome: {
              id: el.id,
              id_pergunta: el.id_pergunta,
              id_diagnostico: el.id_diagnostico,
              resposta: el.resposta,
            },
          })
        })
      this.diagnosticoBackground.respostas
        .filter(el => el.id_pergunta === 'cpf')
        .forEach((el, index) => {
          this.membros[index].cpf = {
            id: el.id,
            id_pergunta: el.id_pergunta,
            id_diagnostico: el.id_diagnostico,
            resposta: el.resposta,
          }
        })
      this.diagnosticoBackground.respostas
        .filter(el => el.id_pergunta === 'idade')
        .forEach((el, index) => {
          this.membros[index].idade = {
            id: el.id,
            id_pergunta: el.id_pergunta,
            id_diagnostico: el.id_diagnostico,
            resposta: el.resposta,
          }
        })
      this.diagnosticoBackground.respostas
        .filter(el => el.id_pergunta === 'sexo')
        .forEach((el, index) => {
          this.membros[index].sexo = {
            id: el.id,
            id_pergunta: el.id_pergunta,
            id_diagnostico: el.id_diagnostico,
            resposta: el.resposta,
          }
        })
      this.membros.forEach(el => {
        el.persisted = true
        if (!el.nome) {
          el.nome = {
            id_pergunta: 'nome',
            id_diagnostico: this.diagnosticoBackground.id,
            resposta: null,
          }
        }
        if (!el.cpf) {
          el.cpf = {
            id_pergunta: 'cpf',
            id_diagnostico: this.diagnosticoBackground.id,
            resposta: null,
          }
        }
        if (!el.idade) {
          el.idade = {
            id_pergunta: 'idade',
            id_diagnostico: this.diagnosticoBackground.id,
            resposta: null,
          }
        }
        if (!el.sexo) {
          el.sexo = {
            id_pergunta: 'sexo',
            id_diagnostico: this.diagnosticoBackground.id,
            resposta: null,
          }
        }
      })
      this.dialogMembros = true
      this.dialogDiagnostico = false
      this.diagnostico = null
    },
    addMembro() {
      this.membros.push({
        nome: {
          id_pergunta: 'nome',
          id_diagnostico: this.diagnosticoBackground.id,
          resposta: null,
        },
        cpf: {
          id_pergunta: 'cpf',
          id_diagnostico: this.diagnosticoBackground.id,
          resposta: null,
        },
        idade: {
          id_pergunta: 'idade',
          id_diagnostico: this.diagnosticoBackground.id,
          resposta: null,
        },
        sexo: {
          id_pergunta: 'sexo',
          id_diagnostico: this.diagnosticoBackground.id,
          resposta: null,
        },
      })
    },
    removeMembro(index) {
      if (this.membros[index].persisted) {
        this.membros[index].delete = true
      } else {
        this.membros.splice(index, 1)
      }
      this.$forceUpdate()
    },
    getDiagnostico(item) {
      this.loadingDiagnostico = true
      this.dialogDiagnostico = true
      this.api.get('diagnostic/get', {params: {id: item.id}}).then(response => {
        this.diagnostico = response.data
        this.diagnosticoBackground = response.data
        this.loadingDiagnostico = false
      })
    },
    geraRelatorio() {
      if (!this.agroindustria && this.user.CodRole === 3) {
        this.Swal.fire('', 'Selecione uma agroindústria.', 'error')
      } else {
        this.loadingRelatorio = true
        this.api
          .get('relatorio/produtores', {
            params: {
              cnpj:
                this.user.CodRole === 3
                  ? this.agroindustria.cnpj
                  : this.user.agroindustria.cnpj,
              data_inicio: this.dataInicio,
              data_fim: this.dataFim,
            },
          })
          .then(response => {
            this.relatorio = response.data
            this.noData = !this.relatorio.length
            this.loadingRelatorio = false
          })
      }
    },
    getAgroindustrias() {
      this.api.get('/agroindustria').then(response => {
        this.agroindustrias = response.data
        this.agroindustrias.forEach(el => {
          el.display_nome = el.Nome + ' - ' + el.cnpj
        })
        this.loading = false
      })
    },
    exportExcel() {
      const newArq = JSON.parse(
        JSON.stringify(
          this.relatorio.map(el => {
            return {
              produtor: el.resposta,
              fazenda: el.fazenda ? el.fazenda.resposta : ' - ',
              consultor: el.consultor ? el.consultor.nome : ' - ',
              regiao: el.regiao || ' - ',
              cidade: el.cidade || ' - ',
              uf: el.estado,
              data: this.moment(el.dataFinalizacao).format('DD/MM/YYYY HH:mm'),
            }
          }),
        ),
      )
      const file = this.XLSX.utils.json_to_sheet(newArq, {
        header: [
          'produtor',
          'fazenda',
          'consultor',
          'regiao',
          'cidade',
          'uf',
          'data',
        ],
      })
      file['!cols'] = []
      file['!cols'][0] = {wpx: 250}
      file['!cols'][1] = {wpx: 200}
      file['!cols'][2] = {wpx: 250}
      file['!cols'][3] = {wpx: 200}
      file['!cols'][4] = {wpx: 200}
      file['!cols'][5] = {wpx: 200}
      file['!cols'][6] = {wpx: 200}
      file.A1.v = 'Produtor'
      file.B1.v = 'Fazenda'
      file.C1.v = 'Consultor'
      file.D1.v = 'Região'
      file.E1.v = 'Cidade'
      file.F1.v = 'UF'
      file.G1.v = 'Data - Hora'
      const wb = this.XLSX.utils.book_new()
      this.XLSX.utils.book_append_sheet(wb, file, 'file')
      if (this.user.CodRole === 3) {
        this.XLSX.writeFile(
          wb,
          'produtores_' + this.agroindustria.Nome.replace(/ /g, '-') + '.xlsx',
        )
      } else {
        this.XLSX.writeFile(
          wb,
          'produtores_' +
            this.user.agroindustria.Nome.replace(/ /g, '-') +
            '.xlsx',
        )
      }
    },
    async exportPDF() {
      this.loadingBtnPDF = true
      const self = this
      const col = [
        'Produtor',
        'Fazenda',
        'Consultor',
        'Região',
        'Cidade',
        'UF',
        'Data - Hora',
      ]
      const rows = this.relatorio.map(function (data) {
        return [
          data.resposta,
          data.fazenda ? data.fazenda.resposta : ' - ',
          data.consultor ? data.consultor.nome : ' - ',
          data.regiao || ' - ',
          data.cidade || ' - ',
          data.estado,
          self.moment(data.dataFinalizacao).format('DD/MM/YYYY HH:mm'),
        ]
      })

      const informacoes = [
        'Agroindústria: ' +
          (this.user.CodRole === 3
            ? this.agroindustria.Nome
            : this.user.agroindustria.Nome),
        'Número de produtores: ' + this.relatorio.length,
        'Período das consultas: ' +
          this.moment(this.dataInicio).format('DD/MM/YYYY') +
          ' à ' +
          this.moment(this.dataFim).format('DD/MM/YYYY'),
        'Data do relatório: ' + this.moment().format('DD/MM/YYYY'),
      ]

      Promise.resolve(
        relatorio.Tabela(
          col,
          rows,
          'Relatório de Produtores',
          informacoes,
          'landscape',
        ),
      ).then(() => {
        this.loadingBtnPDF = false
      })
    },
    async exportDiagnosticoPDF() {
      const dados = []
      dados.push(
        {
          title: 'Agroindústria:',
          content: this.diagnostico.industria_nome,
        },
        {
          title: 'Consultor:',
          content: this.diagnostico.consultor.nome,
        },
        {
          title: 'Região:',
          content: this.diagnostico.regiao || '-',
        },
        {
          title: 'Cidade:',
          content: this.diagnostico.cidade || '-',
        },
        {
          title: 'Estado:',
          content: this.diagnostico.estado || '-',
        },
        {
          title: 'Data da consulta:',
          content: this.moment(this.diagnostico.dataFinalizacao).format(
            'DD/MM/YYYY HH:mm',
          ),
        },
        {
          title: 'Nomes (Com dependentes):',
          content: this.diagnostico.respostas
            .filter(el => el.id_pergunta === 'nome')
            .reduce(
              (acc, curr, index, arr) =>
                acc + curr.resposta + (arr.length - 1 === index ? '' : ', '),
              '',
            ),
        },
        {
          title: 'CPFs (Com dependentes):',
          content: this.diagnostico.respostas
            .filter(el => el.id_pergunta === 'cpf')
            .reduce(
              (acc, curr, index, arr) =>
                acc + curr.resposta + (arr.length - 1 === index ? '' : ', '),
              '',
            ),
        },
        {
          title: 'Idades (Com dependentes):',
          content: this.diagnostico.respostas
            .filter(el => el.id_pergunta === 'idade')
            .reduce(
              (acc, curr, index, arr) =>
                acc + curr.resposta + (arr.length - 1 === index ? '' : ', '),
              '',
            ),
        },
        {
          title: 'Sexos (Com dependentes):',
          content: this.diagnostico.respostas
            .filter(el => el.id_pergunta === 'sexo')
            .reduce(
              (acc, curr, index, arr) =>
                acc + curr.resposta + (arr.length - 1 === index ? '' : ', '),
              '',
            ),
        },
      )
      this.diagnostico.respostas.forEach(el => {
        const dado = this.survey.find(el2 => el2.questionId === el.id_pergunta)
        if (dado) {
          dados.push({
            title: dado.questionText,
            content: el.resposta,
          })
        }
      })
      //  console.log(dados)

      Promise.resolve(listPDF.list(dados, 'Visualização de consulta'))
    },
  },
}
</script>
<style>
.Underline > .v-input__control > .v-input__slot:before {
  border-style: hidden;
}

.diretor-table
  .v-table__overflow
  .v-datatable
  .v-input
  .v-input__control
  .v-input__slot {
  font: 13.3px Roboto;
}

.diretor-table
  .v-table__overflow
  .v-datatable
  .v-input
  .v-input__control
  .v-text-field__slot
  input {
  color: black;
}
.v-input.positivo .v-input__control .v-text-field__slot input {
  font-weight: 500;
  color: teal !important;
}
.v-input.negativo .v-input__control .v-text-field__slot input {
  font-weight: 500;
  color: #f52b1b !important;
}
.list-diagnostico .v-list-item__title {
  font-weight: 400;
  color: #434343;
  text-overflow: unset;
  white-space: unset;
}
.list-diagnostico .v-list-item__subtitle {
  color: #28416a !important;
  font-weight: 500;
  text-overflow: unset;
  white-space: unset;
}
</style>
